var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "475px",
    height: "317px",
    viewBox: "0 0 262 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5036_5945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.672 15.5904L49.9647 41.7844C46.9079 42.4324 44.037 43.7631 41.5669 45.677C39.0968 47.5909 37.0913 50.0385 35.7004 52.8367C34.3095 55.6349 33.5692 58.7113 33.5348 61.8359C33.5004 64.9605 34.1729 68.0525 35.5019 70.8806L74.4953 153.816C76.6967 158.498 80.5698 162.187 85.353 164.158C90.1363 166.129 95.4839 166.24 100.345 164.468L202.953 127.097C207.764 125.344 211.757 121.872 214.16 117.35C216.563 112.828 217.207 107.576 215.968 102.608L198.077 30.8502C196.777 25.6411 193.507 21.1395 188.955 18.2932C184.403 15.4469 178.924 14.478 173.672 15.5904V15.5904Z",
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.672 15.5904L49.9647 41.7844C46.9079 42.4324 44.037 43.7631 41.5669 45.677C39.0968 47.5909 37.0913 50.0385 35.7004 52.8367C34.3095 55.6349 33.5692 58.7113 33.5348 61.8359C33.5004 64.9605 34.1729 68.0525 35.5019 70.8806L74.4953 153.816C76.6967 158.498 80.5698 162.187 85.353 164.158C90.1363 166.129 95.4839 166.24 100.345 164.468L202.953 127.097C207.764 125.344 211.757 121.872 214.16 117.35C216.563 112.828 217.207 107.576 215.968 102.608L198.077 30.8502C196.777 25.6411 193.507 21.1395 188.955 18.2932C184.403 15.4469 178.924 14.478 173.672 15.5904V15.5904Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0524 34.3414L82.1284 38.9797L89.3176 48.1615L95.2415 43.5232L88.0524 34.3414Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5783 29.4627L77.506 37.3491L82.6077 43.8649L92.68 35.9785L87.5783 29.4627Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6804 35.9554L83.4214 40.7334",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0908 33.2862L86.8318 38.0608",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1616 35.8475L85.9026 40.622",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.908 43.5299L170.832 48.1682L178.021 38.9863L172.097 34.348L164.908 43.5299Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.475 35.9768L177.547 43.8632L182.649 37.3474L172.576 29.461L167.475 35.9768Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.479 35.9554L176.738 40.7334",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.068 33.2862L173.327 38.0608",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.997 35.8475L174.256 40.622",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.726 18.2109H123.525V30.4292H135.726V18.2109Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.454 11.2021H120.797V23.4204H138.454V11.2021Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.383 11.1603V21.3428",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.838 21.7987V16.3421",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.383 11.4353V19.1609",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.928 15.1624V22.2546",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.295 11.5258V19.5263",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.755 137.248C199.681 112.322 199.681 71.9089 174.755 46.9831C149.829 22.0572 109.417 22.0572 84.4907 46.9831C59.5648 71.9089 59.5648 112.322 84.4907 137.248C109.417 162.174 149.829 162.173 174.755 137.248Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 131.957C191.469 109.953 191.469 74.2776 169.465 52.2737C147.461 30.2697 111.785 30.2697 89.7813 52.2737C67.7773 74.2776 67.7773 109.953 89.7813 131.957C111.785 153.961 147.461 153.961 169.465 131.957Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.342 128.834C186.621 108.555 186.621 75.6757 166.342 55.3963C146.063 35.117 113.183 35.117 92.904 55.3963C72.6246 75.6757 72.6246 108.555 92.904 128.834C113.183 149.114 146.063 149.114 166.342 128.834Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.625 40.1871V47.2271",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.625 136.952V143.992",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.526 92.0912H174.486",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7612 92.0912H77.7212",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.325 55.3912L161.346 60.3676",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9017 123.811L92.9253 128.791",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9253 55.3912L97.9017 60.3676",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.346 123.811L166.325 128.791",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.435 87.1462L143.246 90.2399L90.1761 103.039L89.9325 102.11L142.435 87.1462Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.661 92.1156C131.661 91.713 131.542 91.3194 131.318 90.9846C131.094 90.6498 130.776 90.3889 130.404 90.2348C130.032 90.0807 129.623 90.0404 129.228 90.119C128.833 90.1975 128.47 90.3914 128.186 90.6761C127.901 90.9608 127.707 91.3236 127.629 91.7185C127.55 92.1134 127.59 92.5227 127.744 92.8947C127.899 93.2667 128.159 93.5846 128.494 93.8083C128.829 94.032 129.223 94.1514 129.625 94.1514C129.893 94.1514 130.157 94.0988 130.404 93.9965C130.651 93.8942 130.876 93.7442 131.065 93.5552C131.254 93.3661 131.404 93.1417 131.506 92.8947C131.608 92.6477 131.661 92.383 131.661 92.1156V92.1156Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.071 130.702L106.887 128.614C106.887 128.614 104.914 130.524 104.799 130.702C104.684 130.879 99.2624 131.527 98.1871 131.527C97.1118 131.527 96.3427 131.273 96.2139 131.784C96.0852 132.296 97.7416 133.437 100.16 134.074C101.114 134.325 102.506 134.826 103.877 135.316L103.661 135.856C103.661 135.856 107.287 137.192 107.861 137.248C108.056 137.272 108.244 136.976 108.408 136.58C108.975 136.068 110.071 130.702 110.071 130.702Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.99 103.467L164.756 107.184C164.756 107.184 167.502 107.219 167.728 107.184C167.954 107.149 172.252 110.5 173.007 111.263C173.762 112.025 174.135 112.742 174.587 112.47C175.039 112.199 174.667 110.222 173.4 108.064C172.899 107.215 172.262 105.879 171.64 104.564L172.172 104.334C172.172 104.334 170.54 100.83 170.178 100.381C170.053 100.228 169.712 100.304 169.318 100.468C168.539 100.443 163.99 103.467 163.99 103.467Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.824 93.525C126.824 93.525 125.804 94.1618 125.933 94.5446C126.062 94.9274 126.887 95.5608 126.887 95.5608C126.887 95.5608 113.433 107.16 113.179 108.051C112.925 108.941 104.792 128.6 104.792 128.6L111.028 131.732L119.352 111.945L133.506 102.897C133.506 102.897 143.737 117.45 144.756 117.325C145.776 117.199 166.708 107.448 166.708 107.448L164.666 102.66L146.98 108.715L141.457 96.3264C141.457 96.3264 142.794 94.0331 141.969 91.8024C141.144 89.5717 138.722 86.137 138.722 86.137L126.824 93.525Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.502 102.879C133.502 102.879 140.281 98.8216 140.855 98.2474",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.803 93.4624C130.585 92.765 131.418 92.1264 132.295 91.5519C133.631 90.7897 136.686 90.915 136.686 90.915",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.649 95.3694C127.649 95.3694 128.101 94.9518 128.742 94.3845",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.148 90.2155C138.148 90.2155 135.604 89.8954 133.624 90.4069",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.093 102.242C135.093 102.242 140.375 103.199 142.094 103.071",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.517 106.331C141.927 106.453 142.334 106.554 142.731 106.634",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.03 103.391C136.741 104.401 138.537 105.261 140.396 105.963",
    stroke: "#B1B7BB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.801 92.3801L126.821 93.525L138.722 86.1404L137.957 85.3783L125.801 92.3801Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.114 77.6388L144.207 79.1108L146.879 78.1851L146.333 76.8732L143.114 77.6388Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.992 66.9065C114.992 66.9065 109.699 66.9831 106.988 66.9065C104.277 66.8299 96.7012 65.3196 96.0957 66.4541C95.4901 67.5886 96.7743 70.6893 100.484 71.9003C104.194 73.1113 112.285 74.2458 112.285 74.2458C112.285 74.2458 115.612 78.4218 117.505 80.9031C119.398 83.3843 122.874 89.1507 123.177 89.6796C123.48 90.2086 124.84 93.4624 126.657 92.7803C128.474 92.0982 138.381 85.9734 138.381 85.5175C138.381 85.0617 138.381 84.4735 138.082 84.0803C137.783 83.6871 134.223 79.3162 133.617 78.1643C133.011 77.0124 130.833 71.434 130.833 71.434L135.597 70.2995C135.597 70.2995 141.196 76.5009 142.254 77.4857C143.312 78.4705 144.221 78.0912 144.221 78.0912C144.221 78.0912 146.719 77.6353 146.792 76.8802C146.865 76.125 138.472 63.2629 137.64 62.8105C136.808 62.3581 131.209 64.2478 128.94 64.6236C126.671 64.9995 123.946 65.1526 120.769 65.9112C118.867 66.3693 116.937 66.7017 114.992 66.9065V66.9065Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.795 71.4479L123.229 73.5637",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.388 72.4292L124.743 74.5485",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.833 71.2878L104.695 70.7658",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.964 70.6161L112.26 74.2458L106.657 71.6706",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.004 82.295C127.666 82.8484 132.312 83.6627 136.231 83.5757",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 81.8008C122.822 81.8008 123.278 81.9157 124.054 82.0897",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.038 82.476C131.038 82.476 134.191 83.1303 136.297 83.1303",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.895 70.9015L116.039 74.733L117.529 70.7867L114.895 70.9015Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.239 68.0131L113.729 69.6766L116.332 71.7611L117.79 69.158L115.239 68.0131Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.729 69.6766L114.46 72.7494L115.5 71.0825L113.729 69.6766Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.888 56.2473C108.888 56.2473 107.844 58.7981 107.9 59.4732C107.955 60.1483 108.474 60.5659 108.422 61.3489C108.37 62.1319 106.755 63.5866 107.12 63.952C107.486 64.3174 108.836 64.8881 108.836 64.8881C108.836 64.8881 110.294 67.9087 110.816 68.0201C111.338 68.1315 114.146 66.7186 114.146 66.7186L116.332 71.7646L120.654 65.3649L119.196 62.5008C119.196 62.5008 120.445 59.2749 119.248 56.6196C118.051 53.9644 114.251 53.8078 112.427 54.121C110.604 54.4342 109.254 55.2067 108.888 56.2473Z",
    fill: "white",
    stroke: "#8E969B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.379 55.68C111.955 55.5901 111.517 55.595 111.096 55.6943C110.675 55.7935 110.281 55.9848 109.943 56.2542C108.645 57.1903 107.548 58.2308 107.03 57.2982C106.511 56.3655 108.123 54.7995 108.123 54.7995C108.123 54.7995 106.821 54.4341 107.343 52.9273C107.865 51.4205 109.779 51.1038 109.779 51.6258C109.779 52.1478 109.622 52.5619 111.081 51.8346C112.539 51.1073 113.318 50.895 113.631 51.7302C113.945 52.5654 115.817 52.0782 117.95 53.2892C120.083 54.5003 120.605 55.2693 120.136 57.9768C119.666 60.6842 119.565 61.9823 119.199 62.5008C118.834 63.0193 117.532 63.1759 116.962 62.9706C116.391 62.7653 116.701 62.1876 116.701 62.1876C116.701 62.1876 118.211 60.6773 117.532 59.4801C116.854 58.283 115.869 58.805 115.556 59.4801C115.243 60.1553 115.399 60.7295 114.929 60.7295C114.46 60.7295 114.046 60.3815 113.941 59.6367C113.837 58.892 113.475 58.2447 113.162 58.1264C112.848 58.0081 112.069 58.7006 112.118 57.5035C112.136 56.813 112.393 56.1501 112.845 55.6278L112.379 55.68Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.892 60.8269C108.878 60.4953 108.987 60.1704 109.197 59.9137C109.408 59.6571 109.705 59.4867 110.033 59.4349",
    stroke: "#8E969B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.12 61.3419C110.221 61.6238 110.19 61.8953 110.054 61.944C109.918 61.9927 109.73 61.7978 109.629 61.5125C109.528 61.2271 109.56 60.9591 109.695 60.9104C109.831 60.8617 110.023 61.0566 110.12 61.3419Z",
    fill: "#8E969B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55 63.691L116.022 69.4678L116.854 72.5406L122.164 65.1491L120.55 63.691Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.036 74.733C116.115 74.9942 116.263 75.2292 116.464 75.413C116.666 75.5968 116.914 75.7226 117.181 75.777C118.096 75.9475 119.697 75.2619 120.497 73.2018C121.298 71.1416 122.958 65.4796 123.929 64.105C124.9 62.7304 128.105 62.6782 129.765 62.7896C131.425 62.901 132.566 61.3036 134.111 60.5589C135.016 60.119 135.979 59.8108 136.972 59.6437L138.92 55.68L134.859 55.5651C134.859 55.5651 130.854 57.4548 129.824 58.6554C128.794 59.856 128.052 59.6994 125.877 60.1413C123.702 60.5833 122.505 61.5159 121.646 64.1468C120.786 66.7777 119.645 73.414 118.385 74.3293C118.063 74.5962 117.677 74.7739 117.264 74.8447C116.852 74.9156 116.429 74.877 116.036 74.733V74.733Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.973 70.4213C102.443 70.9119 102.513 71.6079 102.126 71.9838C101.74 72.3596 101.041 72.2657 100.571 71.7785C100.101 71.2913 100.031 70.5918 100.418 70.2159C100.804 69.8401 101.5 69.948 101.973 70.4213Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.601 71.3713L100.846 70.5709C100.846 70.5709 99.2937 66.5272 97.2231 65.4449C95.1525 64.3626 92.6609 66.0086 92.1423 67.5607C91.6238 69.1128 93.4613 71.7019 95.3892 72.5023C96.9375 73.0822 98.5263 73.5475 100.143 73.8943C100.143 73.8943 101.037 71.7959 101.601 71.3713Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9179 73.5359L98.9979 73.6403C99.6765 73.8108 100.143 73.9117 100.143 73.9117C100.143 73.9117 101.037 71.7959 101.601 71.3713L100.846 70.5709C100.846 70.5709 98.6812 70.9468 98.9179 73.5359Z",
    fill: "#8E969B",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.351 77.6284C106.625 78.0223 106.942 78.3852 107.294 78.7106C107.67 78.996 107.809 79.3231 107.34 79.2779C106.771 79.2643 106.231 79.0266 105.836 78.6167C105.363 78.1016 105.036 77.6771 105.036 77.6771L106.351 77.6284Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.588 76.212C106.588 76.212 107.246 77.2943 107.012 77.5761C106.779 77.858 104.611 77.952 104.281 77.858C103.95 77.7641 104.187 77.3395 104.187 77.3395L106.588 76.212Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.539 74.9487C106.539 74.9487 107.058 75.7491 106.964 76.0763C106.87 76.4034 104.66 77.3952 104.18 77.3465C103.699 77.2977 103.759 76.9254 103.759 76.9254L106.539 74.9487Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.648 74.0057C105.648 74.0057 106.494 73.9117 106.588 74.5242C106.682 75.1367 106.163 75.3246 105.836 75.6065C105.509 75.8883 104.096 76.9254 103.766 76.9254C103.435 76.9254 102.823 75.9823 102.823 75.9823L105.648 74.0057Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.601 71.3713C101.601 71.3713 103.905 72.2205 104.987 72.5023C106.069 72.7842 106.118 73.6786 105.648 74.0057C105.178 74.3328 103.717 76.125 103.292 76.219C102.868 76.3129 102.248 75.8431 102.248 75.8431C102.248 75.8431 100.929 75.1819 100.741 74.6669C100.627 74.3552 100.413 74.0898 100.132 73.9117C100.132 73.9117 100 71.9838 101.601 71.3713Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.259 75.8431C102.259 75.8431 101.883 74.9488 102.213 74.7121C102.544 74.4755 103.059 74.994 103.059 74.994C103.134 74.7213 103.262 74.466 103.435 74.2423",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.224 79.1109C144.349 79.7856 144.427 80.4681 144.457 81.1536C144.419 81.6304 143.587 83.614 143.545 83.7323C143.504 83.8506 143.824 84.3274 143.942 84.484C144.061 84.6406 144.617 84.564 145.052 84.919C145.487 85.2739 146.002 86.1509 146.639 85.963C147.276 85.7751 147.683 84.919 147.683 84.919C147.683 84.919 149.148 84.049 149.187 83.614C149.207 83.0778 149.14 82.5419 148.988 82.0271C148.87 81.6791 146.9 78.1991 146.9 78.1991L144.224 79.1109Z",
    fill: "white",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.638 83.3738C144.638 83.3738 145.39 83.4922 145.71 84.644",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.035 83.9689L143.33 84.8424L144.917 87.8143",
    stroke: "#8E969B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.197 82.5421L149.67 82.3438L151.257 85.514",
    stroke: "#8E969B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.129 82.3327L140.074 89.9443C139.408 90.2412 139.11 91.0211 139.407 91.6862L143.983 101.941C144.28 102.607 145.06 102.905 145.725 102.608L162.781 94.9967C163.446 94.6998 163.745 93.9199 163.448 93.2547L158.871 82.9997C158.574 82.3345 157.795 82.0359 157.129 82.3327Z",
    fill: "#D5D8DA",
    stroke: "#8E969B",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5036_5945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 174,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.b351f525.svg";
export { ForwardRef as ReactComponent };